import { Stack } from '@mui/material';
import { useOrganization } from 'core/stores/hooks/useOrganization';
import { ApolloError } from '@apollo/client';
import { SourcingCandidatesTable } from 'modules/sourcing-shared/tables/SourcingCandidatesTable';
import { SourcingStats } from 'modules/sourcing-shared/components/SourcingStats';
import { useCandidateReportDrawerParams } from 'pages/CandidatesRanking/hooks/useCandidateReportDrawerParams';

type Props = {
  candidateBatchId?: string;
  onSubscriptionError?: (error: ApolloError) => void;
  totalSourcedCandidates: number;
};

export const SourceCandidatesTab: React.FC<Props> = ({
  onSubscriptionError,
  candidateBatchId,
  totalSourcedCandidates
}) => {
  const organization = useOrganization();
  useCandidateReportDrawerParams();

  return (
    <Stack direction="column" gap="40px">
      <SourcingStats
        totalSourcedCandidates={totalSourcedCandidates}
        candidateBatchId={candidateBatchId}
        organizationId={organization.id}
      />
      <SourcingCandidatesTable
        organizationId={organization.id}
        onSubscriptionError={onSubscriptionError}
        candidateBatchId={candidateBatchId}
      />
    </Stack>
  );
};
